import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export interface ApiError {
  statusCode: number;
  message: string;
}

const useVerifyChronologyEvent = (caseId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    ({ factId, verified }: { factId: string; verified: boolean }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: {
          verified: verified,
        },
      });

      if (verified) {
        return fetch(`${APIBaseChronos}/api/case/${caseId}/chronology/fact/${factId}/verify`, fetchConfig).catch(
          (error) => {
            toast.error('Failed to verify fact');
            console.error(error);
          },
        );
      } else {
        return fetch(`${APIBaseChronos}/api/case/${caseId}/chronology/fact/${factId}/unverify`, fetchConfig).catch(
          (error) => {
            toast.error('Failed to unverify fact');
            console.error(error);
          },
        );
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [QueryEntity.ChronologyFacts] });
      },
    },
  );
};

export default useVerifyChronologyEvent;
